import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=23b79103&scoped=true"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=23b79103&prod&lang=scss&scoped=true"
import style1 from "./blacklist.vue?vue&type=style&index=1&id=23b79103&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b79103",
  null
  
)

export default component.exports